import React from 'react';
import {Provider} from 'react-redux'
import { Router } from 'react-router-dom';
import store from './store/configureStore'
import * as Sentry from '@sentry/browser';

//Routes
import Index from "./routes/Index/Index";

//Styles
import "./styles/app.scss";

//Utils
import PropTypes from 'prop-types';

//Utils
import qs from 'querystring';

import history from './services/history';
const { version } = require('../package.json');

Sentry.init({
    dsn: "https://8118b04fe87b4270b5babafb4acd7710@sentry.io/2974818",
    ignoreErrors: [
        "Non-Error promise rejection captured"
    ],
    integrations: [new Sentry.BrowserTracing()],
    release: version || '0.0.0',
    tracesSampleRate: 0.1,
});

const App = ({baseURL, wsBaseURL, companyAPIKey, strictPath, showCloseButton, style, user, password}) => {
    if ((process.env.NODE_ENV && process.env.NODE_ENV !== 'development') || window.top !== window.self) {
        const params = qs.parse(window.location.search.substring(1));
        baseURL = params['baseUrl'];
        wsBaseURL = params['wsBaseUrl'];
        companyAPIKey = params['companyApiKey'];
        strictPath = params['strictPath'];
        showCloseButton = params['showCloseButton'];
        style = params['style'];
        user = params['user'];
        password = params['password'];
    }

    return (
        <Provider store={store}>
            <Router initialEntries={['/']} history={history}>
                <div id='notification' data-testid='data-test-notification'/>
                <Index
                    baseURL={baseURL}
                    wsBaseURL={wsBaseURL}
                    companyAPIKey={companyAPIKey}
                    strictPath={strictPath}
                    showCloseButton={showCloseButton}
                    style={style}
                    user={user}
                    password={password}
                />
            </Router>
        </Provider>
    )
};

App.propTypes = {
    baseURL: PropTypes.string.isRequired,
    companyAPIKey: PropTypes.string.isRequired,
    style: PropTypes.oneOf(['side', 'full', 'inline'])
};

export default App;
